import { IApi } from '../../api'
import { ISaveCampaignRulePayload } from '../../api/campaigns'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'campaigns'

export const [LIST_CAMPAIGNS_REQUEST, LIST_CAMPAIGNS_SUCCESS, LIST_CAMPAIGNS_FAILURE] =
  createRequestTypes(prefix, 'LIST_CAMPAIGNS')

export const listCampaigns = createAction((data: object = {}) => ({
  type: [LIST_CAMPAIGNS_REQUEST, LIST_CAMPAIGNS_SUCCESS, LIST_CAMPAIGNS_FAILURE],
  promise: (api: IApi) => api.campaigns.list(data),
  params: data,
}))

export const [CREATE_CAMPAIGN_REQUEST, CREATE_CAMPAIGN_SUCCESS, CREATE_CAMPAIGN_FAILURE] =
  createRequestTypes(prefix, 'CREATE_CAMPAIGN')

export const createCampaign = createAction((data: object) => ({
  type: [CREATE_CAMPAIGN_REQUEST, CREATE_CAMPAIGN_SUCCESS, CREATE_CAMPAIGN_FAILURE],
  promise: (api: IApi) => api.campaigns.create(data),
}))

export const [SHOW_CAMPAIGN_REQUEST, SHOW_CAMPAIGN_SUCCESS, SHOW_CAMPAIGN_FAILURE] =
  createRequestTypes(prefix, 'SHOW_CAMPAIGN')

export const showCampaign = createAction((id: string) => ({
  type: [SHOW_CAMPAIGN_REQUEST, SHOW_CAMPAIGN_SUCCESS, SHOW_CAMPAIGN_FAILURE],
  promise: (api: IApi) => api.campaigns.show(id),
}))

export const [UPDATE_CAMPAIGN_REQUEST, UPDATE_CAMPAIGN_SUCCESS, UPDATE_CAMPAIGN_FAILURE] =
  createRequestTypes(prefix, 'UPDATE_CAMPAIGN')

export const updateCampaign = createAction((id: string, data: object) => ({
  type: [UPDATE_CAMPAIGN_REQUEST, UPDATE_CAMPAIGN_SUCCESS, UPDATE_CAMPAIGN_FAILURE],
  promise: (api: IApi) => api.campaigns.update(id, data),
}))

export const [LIST_MEMBERS_REQUEST, LIST_MEMBERS_SUCCESS, LIST_MEMBERS_FAILURE] =
  createRequestTypes(prefix, 'LIST_MEMBERS')

export const listCampaignMembers = createAction((id: string, params: object = {}) => ({
  type: [LIST_MEMBERS_REQUEST, LIST_MEMBERS_SUCCESS, LIST_MEMBERS_FAILURE],
  promise: (api: IApi) => api.campaigns.listMembers(id, params),
  params,
}))

export const [ADD_MEMBERS_REQUEST, ADD_MEMBERS_SUCCESS, ADD_MEMBERS_FAILURE] = createRequestTypes(
  prefix,
  'ADD_MEMBERS',
)

export const addCampaignMembers = createAction((id: string, data: object) => ({
  type: [ADD_MEMBERS_REQUEST, ADD_MEMBERS_SUCCESS, ADD_MEMBERS_FAILURE],
  promise: (api: IApi) => api.campaigns.addMembers(id, data),
}))

export const [UPDATE_MEMBER_REQUEST, UPDATE_MEMBER_SUCCESS, UPDATE_MEMBER_FAILURE] =
  createRequestTypes(prefix, 'UPDATE_MEMBER')

export const updateCampaignMember = createAction(
  (campaignId: string, memberId: string, data: object) => ({
    type: [UPDATE_MEMBER_REQUEST, UPDATE_MEMBER_SUCCESS, UPDATE_MEMBER_FAILURE],
    promise: (api: IApi) => api.campaigns.updateMember(campaignId, memberId, data),
  }),
)

export const [
  UPDATE_MEMBERS_STATUS_REQUEST,
  UPDATE_MEMBERS_STATUS_SUCCESS,
  UPDATE_MEMBERS_STATUS_FAILURE,
] = createRequestTypes(prefix, 'UPDATE_MEMBERS_STATUS')

export const updateCampaignMembersStatus = createAction(
  (campaignId: string, data: { ids: string[]; status: string }) => ({
    type: [
      UPDATE_MEMBERS_STATUS_REQUEST,
      UPDATE_MEMBERS_STATUS_SUCCESS,
      UPDATE_MEMBERS_STATUS_FAILURE,
    ],
    promise: (api: IApi) => api.campaigns.updateMembersStatus(campaignId, data),
  }),
)

export const [REMOVE_MEMBER_REQUEST, REMOVE_MEMBER_SUCCESS, REMOVE_MEMBER_FAILURE] =
  createRequestTypes(prefix, 'REMOVE_MEMBER')

export const removeCampaignMember = createAction((campaignId: string, memberId: string) => ({
  type: [REMOVE_MEMBER_REQUEST, REMOVE_MEMBER_SUCCESS, REMOVE_MEMBER_FAILURE],
  promise: (api: IApi) => api.campaigns.removeMember(campaignId, memberId),
}))

export const [LIST_REFERRALS_REQUEST, LIST_REFERRALS_SUCCESS, LIST_REFERRALS_FAILURE] =
  createRequestTypes(prefix, 'LIST_REFERRALS')

export const listCampaignReferrals = createAction((id: string) => ({
  type: [LIST_REFERRALS_REQUEST, LIST_REFERRALS_SUCCESS, LIST_REFERRALS_FAILURE],
  promise: (api: IApi) => api.campaigns.listReferrals(id),
}))

export const [LIST_EXPENSES_REQUEST, LIST_EXPENSES_SUCCESS, LIST_EXPENSES_FAILURE] =
  createRequestTypes(prefix, 'LIST_EXPENSES')

export const listCampaignExpenses = createAction((id: string) => ({
  type: [LIST_EXPENSES_REQUEST, LIST_EXPENSES_SUCCESS, LIST_EXPENSES_FAILURE],
  promise: (api: IApi) => api.campaigns.listExpenses(id),
}))

export const [LIST_RULES_REQUEST, LIST_RULES_SUCCESS, LIST_RULES_FAILURE] = createRequestTypes(
  prefix,
  'LIST_RULES',
)

export const listCampaignRules = createAction((id: string) => ({
  type: [LIST_RULES_REQUEST, LIST_RULES_SUCCESS, LIST_RULES_FAILURE],
  promise: (api: IApi) => api.campaigns.listRules(id),
}))

export const [SAVE_RULE_REQUEST, SAVE_RULE_SUCCESS, SAVE_RULE_FAILURE] = createRequestTypes(
  prefix,
  'SAVE_RULE',
)

export const saveCampaignRule = createAction(
  (campaignId: string, data: ISaveCampaignRulePayload) => ({
    type: [SAVE_RULE_REQUEST, SAVE_RULE_SUCCESS, SAVE_RULE_FAILURE],
    promise: (api: IApi) => api.campaigns.saveRule(campaignId, data),
  }),
)

export const [DELETE_RULE_REQUEST, DELETE_RULE_SUCCESS, DELETE_RULE_FAILURE] = createRequestTypes(
  prefix,
  'DELETE_RULE',
)

export const deleteCampaignRule = createAction((campaignId: string, ruleId: string) => ({
  type: [DELETE_RULE_REQUEST, DELETE_RULE_SUCCESS, DELETE_RULE_FAILURE],
  promise: (api: IApi) => api.campaigns.deleteRule(campaignId, ruleId),
}))
